module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Folder-df295d1ed6f5f4632c14fe444e00f3af.svg";